import { DotLoading } from "antd-mobile";

export default function LoadingView({msg}: {msg?: String}) {
    return <div style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <span style={{marginRight: 8}}>{msg ?? 'Đang tải'}</span><DotLoading color='#FD5B3A' />
      </div>
}